import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./NDACommitment.css";

const NDACommitment = () => {
  return (
    /* Parent Class Wrapper added here */
    <div className="nda-page-wrapper">
      <Container>
        <div className="nda-container">
          <Card className="nda-card">
            <Card.Body className="nda-body">
              {/* Header Section */}
              <div className="nda-header">
                <h1 className="nda-title">NDA COMMITMENT STATEMENT</h1>
                <p className="nda-subtitle">
                  Non-Disclosure & Confidentiality Commitment
                </p>
              </div>

              <hr className="nda-divider" />

              {/* Introduction */}
              <p className="nda-intro">
                <strong>Diligencia Solutions & Services Pvt. Ltd.</strong>{" "}
                understands that clients entrust us with valuable business
                information.
              </p>

              {/* Commitments List */}
              <div className="nda-commitments-box">
                <h3 className="list-title">We are committed to:</h3>
                <ul className="nda-list">
                  <li>
                    <span className="bullet-icon">✦</span>
                    <span className="list-text">
                      Maintaining confidentiality of all client information.
                    </span>
                  </li>
                  <li>
                    <span className="bullet-icon">✦</span>
                    <span className="list-text">
                      Signing project-specific Non-Disclosure Agreements (NDAs)
                      whenever required.
                    </span>
                  </li>
                  <li>
                    <span className="bullet-icon">✦</span>
                    <span className="list-text">
                      Restricting access to authorized personnel only.
                    </span>
                  </li>
                  <li>
                    <span className="bullet-icon">✦</span>
                    <span className="list-text">
                      Preventing unauthorized disclosure, copying, or
                      distribution of client information.
                    </span>
                  </li>
                  <li>
                    <span className="bullet-icon">✦</span>
                    <span className="list-text">
                      Protecting intellectual property and proprietary
                      information.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Footer text */}
              <p className="nda-footer-text">
                Our team follows strict professional standards to ensure
                sensitive business information remains secure throughout the
                engagement lifecycle.
              </p>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default NDACommitment;
